/**
 * Tiny dev HUD: FPS, frame ms, boost, trauma. Gated behind `?debug=1`
 * so production users never see it. Polls a snapshot fn at 4 Hz so the
 * numbers don't jitter at full frame rate.
 */

export interface PerfSnapshot {
  avgMs: number;
  fps: number;
  boost: number;
  trauma: number;
}

export function maybeMountPerfHud(snapshot: () => PerfSnapshot): void {
  if (new URLSearchParams(location.search).get("debug") !== "1") return;
  const el = document.createElement("div");
  el.className = "perf-hud";
  el.setAttribute("aria-hidden", "true");
  document.body.appendChild(el);
  const tick = () => {
    const s = snapshot();
    el.innerHTML = `
      <span><b>${s.fps.toFixed(0)}</b> fps</span>
      <span>${s.avgMs.toFixed(1)} ms</span>
      <span>boost ${(s.boost * 100).toFixed(0)}%</span>
      <span>trauma ${(s.trauma * 100).toFixed(0)}%</span>
    `;
  };
  tick();
  window.setInterval(tick, 250);
}
